import React, { useState, useEffect } from "react";
import { IconButton, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";

import Modal from "../../components/Modal/Modal";
import formFields from "../../config/formFields.json";

import { useLoading } from "../../contexts/LoadingContext";
import FormValidation from "../../components/FormValidation/FormValidation";

const AddCity = ({
    open,
    onClose,
    initialData = null,
    onSubmit,
    countries = [],
}) => {
    console.log("countries",countries)
    const isEdit = !!initialData;
    const initialFormState = {
        city_name: "",
        country_id: null,
    };

    const [formData, setFormData] = useState(initialFormState);
    const [errorModal, setErrorModal] = useState(null);
    const { showLoading, hideLoading } = useLoading();
    const getOptionsForField = (source) => {
        switch (source) {
            case "Country":
                return countries.map((countryId) => ({
                    value: countryId.country_id.toString(),
                    label: countryId.country_name,
                }));
            default:
                return [];
        }
    };

    useEffect(() => {
        if (open) {
            if (initialData) {
                setFormData({
                    city_name: initialData?.city_name || "",
                    country_id:initialData?.country_id?.toString() || null
                });
            } else {
                setFormData(initialFormState);
            }
        } else {
            setFormData(initialFormState);
        }
        setErrorModal(null);
    }, [initialData, open]);

    const handleSubmit = async (e) => {
        // e.preventDefault();
        setErrorModal(null);

        try {
            showLoading();
            await onSubmit({
                ...e
            });
            setFormData(initialFormState);
        } catch (error) {
            setErrorModal({
                type: "error",
                title: "Action Failed",
                message: error.message || "Something went wrong",
            });
        } finally {
            hideLoading();
        }
    };

    const handleClose = () => {
        setFormData(initialFormState);
        setErrorModal(null);
        onClose();
    };

    const handleErrorModalClose = () => {
        setErrorModal(null);
    };

    return (
        <>

            <FormValidation
                modelWidth={"60vw"}
                open={open}
                onClose={handleClose}
                initialData={formData}
                onSubmit={handleSubmit}
                formFields={formFields.city.basic.fields}
                title="City"
                icon={BusinessIcon}
                isEdit={isEdit}
                getOptionsForField={getOptionsForField}
            />

            {errorModal && (
                <Modal
                    type={errorModal.type}
                    title={errorModal.title}
                    message={errorModal.message}
                    onClose={handleErrorModalClose}
                />
            )}
        </>
    );
};

export default AddCity;
